module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DateQuestion', {
    ref: "child",
    attrs: {
      "question": _vm.question,
      "answer": _vm.answer,
      "isDisabled": _vm.isDisabled,
      "disableFutureDates": true
    },
    on: {
      "answerUpdated": _vm.onAnswerUpdated
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b76302f0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/quizzes/questions/DateLteTodayQuestion.vue
// module id = 706
// module chunks = 1